import SimpleLightbox from 'simplelightbox';

// Docs: https://simplelightbox.com/
new SimpleLightbox('.gallery a', {
    showCounter: false,
    fadeSpeed: 0
});
